"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
// ORGANISM
var Styles_1 = require("./ModalFlexible/Styles");
var Styles_2 = require("./Modal/Styles");
var Styles_3 = require("./TimeLineList/Styles");
var Styles_4 = require("./LineList/Styles");
var Styles_5 = require("./CardEventList/Styles");
var Styles_6 = require("./FilePicker/Styles");
var Styles_7 = require("./HelpModal/Styles");
var Styles_8 = require("./GenericConfirmationModal/Styles");
exports.default = styled_components_1.createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"], ["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n"])), Styles_1.StylesModalFlexible, Styles_2.StylesModal, Styles_3.StylesTimeLineList, Styles_4.StylesLineList, Styles_6.StylesFilePicker, Styles_5.StylesCardEventList, Styles_7.StylesHelpModal, Styles_8.StylesGenericConfirmationModal);
var templateObject_1;
